import { register } from '@tokens-studio/sd-transforms'
import StyleDictionary from 'style-dictionary'
import { Theme, TransformedTheme } from '../../types'

export interface TransformResult {
  json: TransformedTheme
  jsonFlat: Record<string, string>
}

const formatOutput = (output: string | undefined) => {
  return output ? JSON.parse(output) : {}
}

/**
 * Transform theme, calculate all tokens.
 * @param theme
 * @returns
 */
export const transformTheme = async (theme: Theme): Promise<TransformResult> => {
  await register(StyleDictionary, {
    'ts/color/modifiers': {
      format: 'hex',
    },
  })

  const dictionary = new StyleDictionary({
    source: [''],
    tokens: {
      ...theme.color,
      ...theme.theme,
    },
    log: {
      errors: {
        brokenReferences: 'console',
      },
      verbosity: 'silent',
    },
    preprocessors: ['tokens-studio'],
    platforms: {
      json: {
        transformGroup: 'tokens-studio',
        transforms: ['name/kebab', 'ts/resolveMath'],
        files: [{ format: 'json' }],
      },
      jsonFlat: {
        transformGroup: 'tokens-studio',
        transforms: ['name/kebab', 'ts/resolveMath'],
        files: [{ format: 'json/flat' }],
      },
    },
  })

  const json = await dictionary.formatPlatform('json')
  const jsonFlat = await dictionary.formatPlatform('jsonFlat')

  return {
    json: formatOutput(json.at(0)?.output as string),
    jsonFlat: formatOutput(jsonFlat.at(0)?.output as string),
  }
}
